import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 20px;
`;

export { Container };
